import { useCallback, useEffect, useState } from "react";
import { Input, Table } from "antd";
import { createPDFimagenH002 } from "../../Service/Service.laboratorioPDF";
import { ListarPacienteCitasHistorial } from "../../Service/Service.paciente";

export default function HistorialCitasCompleto({ idpaciente, onConsultar, onLlamar }) {
  const [loading, setLoading] = useState(false);
  const [citas, setCitas] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const fetchCitas = useCallback(async (page = 1, limit = 10, searchValue = "") => {
    if (!idpaciente) return;

    setLoading(true);
    const result = await ListarPacienteCitasHistorial({ idpaciente, page, limit, search: searchValue });

    if (result?.success) {
      setCitas(result.data || []);
      setTotal(result.pagination?.total || 0);
      setCurrentPage(result.pagination?.page || page);
      setPageSize(result.pagination?.limit || limit);
    }

    setLoading(false);
  }, [idpaciente]);

  useEffect(() => {
    fetchCitas(1, pageSize, search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchCitas]);

  const handleSearch = (value) => {
    setSearch(value);
    fetchCitas(1, pageSize, value);
  };

  const handleTableChange = (pagination) => {
    fetchCitas(pagination.current, pagination.pageSize, search);
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "fecha_inicio",
      key: "fecha_inicio",
    },
    {
      title: "Hora",
      dataIndex: "hora_inicio",
      key: "hora_inicio",
    },
    {
      title: "Doctor",
      key: "doctor",
      render: (_, cita) => cita.doctor?.nombre || "Sin doctor",
    },
    {
      title: "Estado",
      key: "estado",
      render: (_, cita) => (
        <span
          className={`badge px-3 py-2 mt-1 fw-bold fs-6 rounded-pill shadow-sm ${
            cita.estado_cita.estado === "Finalizada"
              ? "bg-success"
              : cita.estado_cita.estado === "En Consulta"
              ? "bg-warning"
              : cita.estado_cita.estado === "Cancelada"
              ? "bg-danger"
              : "bg-secondary"
          }`}
        >
          {cita.estado_cita.estado}
        </span>
      ),
    },
    {
      title: "Opción",
      key: "accion",
      render: (_, cita) => (
        <>
          <span
            className="btn btn-sm btn-soft-primary rounded-pill shadow-sm"
            onClick={() => onConsultar(cita.idcita)}
          >
            Ver <i className="fas fa-eye mx-1"></i>
          </span>

          <span
            className="btn btn-sm btn-soft-success ms-2 rounded-pill shadow-sm"
            onClick={() => onLlamar(cita)}
          >
            Llamar <i className="fas fa-ticket-alt mx-1"></i>
          </span>
          <span
            className="btn btn-sm btn-soft-primary ms-2 rounded-pill shadow-sm"
            onClick={() => createPDFimagenH002(cita.idcita)}
          >
            H002 <i className="fas fa-eye mx-1"></i>
          </span>
        </>
      ),
    },
  ];

  return (
    <div>
      <h5 className="card-title mb-3">Listado de Citas</h5>

      <div className="mb-3" style={{ maxWidth: 320 }}>
        <Input.Search
          placeholder="Buscar por doctor o estado..."
          allowClear
          onSearch={handleSearch}
        />
      </div>

      <Table
        rowKey="idcita"
        loading={loading}
        columns={columns}
        size="small"
        onChange={handleTableChange}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: total,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total) => `Total ${total} citas`,
        }}
        dataSource={citas}
      />
    </div>
  );
}
